import colors from '../../constants/js/colors.js';
import hexToRGB from '../../utils/hexToRGB';
export const colorText = {
    primary: colors.minorDarkBlue,
    secondary: colors.silverStrong,
    tertiary: colors.majorGray,
    disabled: hexToRGB(colors.majorGray, 0.7),
    positive: colors.majorGreen,
    destructive: colors.majorRed,
    orange: colors.minorOrange,
    white: colors.majorWhite,
};
export const getColorStylesLegacy = (value) => `
	color: ${colorText[value]};
`;
